import { render, staticRenderFns } from "./PortalQuestionnaires.vue?vue&type=template&id=17414b56&"
import script from "./PortalQuestionnaires.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalQuestionnaires.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports